import React from "react";
import Pageslayout from "../../Layouts/Pageslayout";
import PageIntro from "../../components/PageIntro";
const Index = ({ title, description }) => {
  return (
    <Pageslayout
      pageintro={true}
      title="Latest Real Estate Trends in Pakistan"
      description="Please stay tuned for further updates."
    >x</Pageslayout>
  );
};

export default Index;
